import { startCase } from 'lodash';
import { useCallback, VFC } from 'react';

import ReactSelect from 'dashboard/components/ReactSelect';
import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import { ParamsBaseProps } from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsBaseProps';
import { WorkflowActionUpdateInquiryNextStepNameV1 } from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';

export interface ParamsRouteInquiryStepV1Props extends ParamsBaseProps {
  steps: { name: string }[] | undefined;
  params: WorkflowActionUpdateInquiryNextStepNameV1['params'];
  editable: boolean;
  updateActionParams: (newParams: WorkflowActionUpdateInquiryNextStepNameV1['params']) => void;
}

const ParamsRouteInquiryStepV1: VFC<ParamsRouteInquiryStepV1Props> = ({
  steps,
  params,
  editable,
  updateActionParams,
}) => {
  // TODO: update to use step.name_display once naming audit is finished
  const stepOptions = (steps ?? []).map((step) => ({
    label: startCase(step.name),
    value: step.name,
  }));
  const selectedStepName = params['next-step-name'];
  if (stepOptions.find((option) => option.value === selectedStepName) == null) {
    // Account for steps that were newly created in ITE
    stepOptions.push({
      label: startCase(selectedStepName),
      value: selectedStepName,
    });
  }
  const updateParams = useCallback(
    (stepName: string) =>
      updateActionParams({
        ...params,
        'next-step-name': stepName,
      }),
    [params, updateActionParams],
  );
  return stepOptions.length > 1 ? (
    <>
      <Spacer height={2} />
      <ParamLabel labelText='Step' htmlFor='params-route-inquiry-step__step-input' />
      <ReactSelect
        value={params['next-step-name']}
        options={stepOptions}
        onChange={updateParams}
        id='params-route-inquiry-step__step'
        disabled={!editable}
      />
      <Spacer height={2} />
    </>
  ) : null;
};

export default ParamsRouteInquiryStepV1;
